<template>
	<li class="navigation-entry-with-dropdown">
		<div class="lang-selection" @click="toggleLanguageDropdown">
			<img class="lang-flag-round" :src="localeFlag" />
			<span id="lang-dropdown-entry">{{ currentLocale.toUpperCase() }}</span>
			<img id="lang-dropdown-entry-icon" :src="iconExpandDown" />
		</div>
		<ul
			v-if="isLangDropdownOpen"
			id="lang-dropdown"
			class="navigation-dropdown-list"
		>
			<li
				class="lang-selection lang-selection-dropdwon"
				:class="getActiveStateClassname('de')"
				@click="changeLang('de')"
			>
				<img class="lang-flag-round" :src="flagDE" />
				<span>DE</span>
			</li>
			<li
				class="lang-selection lang-selection-dropdwon"
				:class="getActiveStateClassname('en')"
				@click="changeLang('en')"
			>
				<img class="lang-flag-round" :src="flagEN" />
				<span>EN</span>
			</li>
		</ul>
	</li>
</template>
<script>
import WikipediaFlagsDE from '@/assets/WikipediaFlags_DE.svg'
import WikipediaFlagsUS from '@/assets/WikipediaFlags_US.svg'
import IconExpandDown from '@/assets/icons/expand_down.svg'

export default {
	name: 'LanguageSelectorEntry',
	data() {
		return {
			flagDE: WikipediaFlagsDE,
			flagEN: WikipediaFlagsUS,
			iconExpandDown: IconExpandDown,
			isLangDropdownOpen: false
		}
	},
	computed: {
		currentLocale() {
			return this.$i18n.locale
		},
		localeFlag() {
			if (this.currentLocale === 'de') {
				return this.flagDE
			} else {
				return this.flagEN
			}
		}
	},
	methods: {
		toggleLanguageDropdown() {
			this.isLangDropdownOpen = !this.isLangDropdownOpen
		},
		handleOutsideClick(ev) {
			if (document.getElementById('lang-dropdown')) {
				if (
					ev &&
					ev.target &&
					ev.target.id !== 'lang-dropdown-entry' &&
					ev.target.id !== 'lang-dropdown-entry-icon' &&
					ev.target.id !== 'lang-dropdown'
				) {
					this.toggleLanguageDropdown()
				}
			}
		},
		changeLang(lang) {
			if (this.currentLocale !== lang) {
				localStorage.setItem('lang', lang)
				location.reload()
			}
		},
		getActiveStateClassname(lang) {
			return this.currentLocale === lang ? 'active-lang' : ''
		}
	},
	mounted() {
		document.addEventListener('click', this.handleOutsideClick)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleOutsideClick)
	}
}
</script>

<style lang="stylus" scoped>
.navigation-entry-with-dropdown {
	position: relative;
}
.navigation-dropdown-list {
	position: absolute;
	background-color: #000;
	width: 100%;
	top: 45px;
	padding-left: 10px;
	border-top: solid red 1px;
}
.navigation-dropdown-list > li {
	margin: 20px 0px;
}
.navigation-entry-with-dropdown div {
	display: flex;
	align-items: center;
	cursor: pointer;
}
.lang-selection {
	display: flex;
	align-items: center;
	color: white;
	cursor: pointer;
}
.lang-flag-round {
	width: 22px;
	height: 22px;
	border-radius: 50%;
	margin-right: 6px;
	border: 1px solid rgba(255,255,255,0.3);
}

.lang-selection-dropdwon:hover {
    color: red;
	text-decoration: underline;
}
.active-lang {
	color: red;
}
</style>
